import { Summary } from 'components/Summary';
import { useHasWorkspacePermission } from 'hooks/useHasWorkspacePermission';
import React, { useCallback, useState } from 'react';
import { match } from 'ts-pattern';
import { formatDateTime } from 'utils/date';

import { Permissions } from '@fragment/authorization-utils/permissions';
import { PrimaryButtonV2 } from '@fragment/ui/src/components/Button/PrimaryButtonV2/PrimaryButtonV2';

import { UpdateUnitLinkForm } from './UpdateUnitLinkForm';

type Props = {
  workspaceId: string;
  encodedLinkId: string;
  lastUpdatedTs?: string;
};

export const UnitLinkDetail = ({
  workspaceId,
  encodedLinkId,
  lastUpdatedTs,
}: Props) => {
  const canUpdate = useHasWorkspacePermission(Permissions.link.update);
  const [isFormActive, setIsFormActive] = useState(false);
  const onClick = useCallback(() => setIsFormActive(true), [setIsFormActive]);
  const closeForm = useCallback(
    () => setIsFormActive(false),
    [setIsFormActive]
  );
  return (
    <div className="flex flex-col space-y-f3">
      {match(isFormActive)
        .with(false, () => (
          <>
            <Summary.Table
              values={[
                {
                  header: `Org API Token`,
                  value: (
                    <div className="ml-ftwo-thirds">
                      {lastUpdatedTs ? '*'.repeat(37) : 'None'}
                    </div>
                  ),
                },
                {
                  header: 'Updated',
                  value: (
                    <div className="ml-ftwo-thirds">
                      {lastUpdatedTs ? formatDateTime(lastUpdatedTs) : 'N/A'}
                    </div>
                  ),
                },
              ]}
            />
            {canUpdate && (
              <div className="flex w-fit space-x-f2">
                <PrimaryButtonV2 onClick={onClick}>
                  {lastUpdatedTs ? 'Update Token' : 'Add Token'}
                </PrimaryButtonV2>
              </div>
            )}
          </>
        ))
        .otherwise(() => (
          <UpdateUnitLinkForm
            onFormClose={closeForm}
            workspaceId={workspaceId}
            encodedLinkId={encodedLinkId}
          />
        ))}
    </div>
  );
};
